import AllAnnouncements from './AllAnnouncements.gql';

export default AllAnnouncements;
